import { PRODUCT_PAGE_ROUTES, GROUPED_BY, SHARE_OF_SEARCH_ROUTES, STOCK_ROUTES } from "@constants"
import { encodeCommonFiltersShareValue, commonFiltersShareValue, commonFiltersValue } from "@signals"


export const URL_OPTIONS = {
	shareOfsearch: SHARE_OF_SEARCH_ROUTES.SHARE_PATH,
	productPages: PRODUCT_PAGE_ROUTES.KPIS_PATH,
	stockAssortment: STOCK_ROUTES.STOCK_ASSORT_PATH
}

export default function useDigitalShelfRedirect(name, dataRow) {

	const specificFilters = {
		country: dataRow?.country ? [GROUPED_BY.COUNTRY ? dataRow.country.toLowerCase() : dataRow.country] : commonFiltersValue.peek().country,
		retailer: dataRow?.siteID ? [dataRow.siteID] : commonFiltersValue.peek().retailer,
		brand: dataRow?.brandID ? [dataRow.brandID] : commonFiltersValue.peek().brand,
		splitKpi: [GROUPED_BY.RETAILER]
	}

	const combinedFilters = {
		...commonFiltersShareValue.peek(),
		...specificFilters,
	}

	if (combinedFilters?.sku?.length > 500)
		combinedFilters.sku = []
	
	return {
		urlDetails: name?.length > 0 ? `${URL_OPTIONS[name]}?sp=${encodeCommonFiltersShareValue(combinedFilters)}` : null
	}
}